import React from 'react';
import PropTypes from 'prop-types';
import { MdSearch as SearchIcon } from 'react-icons/md';

import Spinner from '../../../../shared/spinner.component';
import { HelpContentPropTypes } from '../../../shared/proptypes';

const SearchDocs = ({ onSearchChange, searchText, isLoading, searchResults, onClick }) => (
  <div className="search-docs-wrapper">
    <label className="search-docs-bar border shadow-sm rounded">
      <SearchIcon />
      <input value={searchText} className="search-docs-bar-input" onChange={onSearchChange} autoFocus />
    </label>
    {isLoading && <Spinner />}
    {searchResults.map(content => (
      <button
        // eslint-disable-next-line react/jsx-no-bind
        onClick={() => onClick(content)}
        key={content.contentId}
        className="docs-result-wrapper shadow-sm border rounded"
      >
        <div className="docs-result-header">
          <div>{content.title}</div>
          <span>{content.section}</span>
        </div>
      </button>
    ))}
  </div>
);

SearchDocs.propTypes = {
  onSearchChange: PropTypes.func.isRequired,
  searchText: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  searchResults: PropTypes.arrayOf(HelpContentPropTypes).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default SearchDocs;
